import { useState } from 'react';

import { Select } from '@toolbox/components';
import { useField } from '@toolbox/form';

import type { SelectChangeEvent } from '@mui/material';
import type { z } from 'zod';
import type { SelectSchema } from '@widget/storyblok/schemas';

type SelectProps = z.infer<typeof SelectSchema>;

export const SelectField = ({ name, numeric, required, ...props }: SelectProps): JSX.Element => {
  const { field, fieldState } = useField({
    name,
    rules: {
      required: !!required,
    },
  });

  const [value, setValue] = useState<string>(field.value ?? '');

  const handleChange = (event: SelectChangeEvent<unknown>): void => {
    const target = event.target as HTMLInputElement;
    const value = numeric ? Number(target.value) : target.value;
    setValue(target.value || '');
    field.onChange(value);
  };

  return (
    <div>
      <Select
        {...props}
        label={props.label || ''}
        value={value}
        onChange={handleChange}
        error={!!fieldState.error?.message}
        helperText={fieldState.error?.message}
        MenuProps={{
          disableScrollLock: true,
        }}
      />
    </div>
  );
};
